import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.NODE_ENV === 'production' ? '/airdrop-register' : '/',
  routes: [
    {
      path: '/',
      component: () => import(/* webpackChunkName: "Home" */ './pages/Home'),
      name: 'Home',
    },
    {
      path: '/register',
      component: () =>
        import(/* webpackChunkName: "Register" */ './pages/Register'),
      name: 'Register',
    },
  ],
})

export default router
